import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ProjectUpdateModalUI from './ProjectUpdateModalUI.js'

class ProjectUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      customerId: '',
      customerIdError: null,
      projectName: this.props.selectedProject ? this.props.selectedProject.projectName : '',
      projectNameError: null,
      projectCostF: this.props.selectedProject ? this.props.selectedProject.projectCost : '',
      projectCostFError: null,
      expectedMarginPercent: this.props.selectedProject ? this.props.selectedProject.expectedMarginPercent : '',
      expectedMarginPercentError: null
    }
  }

  render() {
    return (
      <ProjectUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onUpdateClick={this.onSubmit}
        onCancelCreate={this.onCancelCreate}
        onCancelUpdate={this.onCancelUpdate}
        // form fields
        customerId={this.state.customerId}
        onCustomerIdChange={(event) => { this.setState({ customerId: event.target.value }) }}
        customerIdError={this.state.customerIdError}
        setCustomerIdError={(error) => { this.setState({ customerIdError: error }) }}
        customerList={this.props.customerList}
        //
        projectName={this.state.projectName}
        onProjectNameChange={(event) => { this.setState({ projectName: event.target.value }) }}
        projectNameError={this.state.projectNameError}
        setProjectNameError={(error) => { this.setState({ projectNameError: error }) }}
        //
        projectCostF={this.state.projectCostF}
        onProjectCostChange={(event) => { this.setState({ projectCostF: event.target.value }) }}
        projectCostError={this.state.projectCostError}
        setProjectCostFError={(error) => { this.setState({ projectCostFError: error }) }}
        //
        expectedMarginPercent={this.state.expectedMarginPercent}
        onExpectedMarginPercentChange={(event) => { this.setState({ expectedMarginPercent: event.target.value }) }}
        expectedMarginPercentError={this.state.expectedMarginPercentError}
        setExpectedMarginPercentError={(error) => { this.setState({ expectedMarginPercentError: error }) }}
      />
    )
  }

  onCancelUpdate = () => {
    this.setState({
      submitted: false, successMsg: null, errorList: null,
      projectNameError: null,
      projectCostFError: null,
      expectedMarginPercentError: null
    })
    this.props.onCancelUpdate()
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
    this.setState({
      // loanTypeList: loanTypeList,
      // appFlavorList: appFlavorList, loanPurposeList: loanPurposeList
    })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/projects/${this.props.selectedProject.projectId}`,
      this.onSubmitCallback, {
      projectName: this.state.projectName,
      projectCostF: this.state.projectCostF,
      expectedMarginPercent: this.state.expectedMarginPercent,
      customerId: this.state.customerId
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Loans())
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelUpdate()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default ProjectUpdateModalSF
